import { Order } from "../../order.model";
import { DayOfWeek } from "src/app/core";
import { VenueSummary } from "../../models/venue-summary.model";
import { CitySummary } from "../../models/city-summary.model";
import { ProductType } from "src/app/core/product/enums";
export abstract class IOrderData {
  public key: number | string;
  public units: number;
  public subtotal: number;
  public fees: number;
  public tips: number;
  public redeemedUnits: number;
  public orders: number;
  public revenue: number;
  constructor() {
    this.units = 0;
    this.subtotal = 0;
    this.fees = 0;
    this.tips = 0;
    this.redeemedUnits = 0;
    this.orders = 0;
    this.revenue = 0;
  }
  public get avgPrice(): number {
    return this.units == 0 ? 0 : this.subtotal / this.units;
  }
  public get tipPercent(): number {
    return this.subtotal == 0 ? 0 : this.tips / this.subtotal;
  }
  public get redeemedPercent(): number {
    return this.units == 0 ? 0 : this.redeemedUnits / this.units;
  }

  add(key: number | string, order: Order) {
    if (this.key != key) return;
    this.orders += 1;
    this.revenue += order.summary.total;
    this.units += order.summary.units;
    if (order.summary.redeemedAt != null)
      this.redeemedUnits += order.summary.units;
    if (order.summary.tip != null) this.tips += order.summary.tip;
  
    // INCREMENT SUBTOTAL & FEE DEPENDING ON SOME SHIT

    if (order.menu != null) {
      this.subtotal += order.summary.subtotal ?? 0;
      this.fees += order.summary.serviceFee ?? 0;
    } else {
      //CHECK IF PERCENT FEE OR FLAT FEE (if SUBTOTAL)
      var subtotal = order.summary.price * order.summary.units;
      var tip = order.summary.tip ?? 0;
      this.subtotal += subtotal;
      this.fees += (order.summary.total - tip - subtotal);
    }
  }
}

export class OrderFactoryDayOfWeekData extends IOrderData {
  private _days: Map<string, boolean>;
  constructor(public readonly key: number, public readonly dow: DayOfWeek) {
    super();
    this._days = new Map();
  }

  public get days(): number {
    return this._days.size;
  }

  add(key: number, order: Order) {
    if (this.key == key) {
      if (order.event.reference != null)
        this._days.set(order.event.reference.id, true);
    }
    super.add(key, order);
  }
}
export class OrderFactoryEventData extends IOrderData {
  constructor(public readonly key: string, public readonly day: number) {
    super();
  }

  add(key: string, order: Order) {
    super.add(key, order);
  }
}
export class OrderFactoryVenueData extends IOrderData {
  constructor(
    public readonly key: string,
    public readonly venue: VenueSummary,
    public readonly city: CitySummary
  ) {
    super();
  }
}

export class OrderFactoryCityData extends IOrderData {
  private _venues: Map<string, boolean>;

  constructor(public readonly key: string, public readonly city: CitySummary) {
    super();
    this._venues = new Map();
  }

  public add(key: string, order: Order) {
    if (this.key == key) {
      this._venues.set(order.venue.reference.id, true);
    }
    super.add(key, order);
  }
  public get venues(): number {
    return this._venues.size;
  }
}

export class OrderFactoryProductData extends IOrderData {
  constructor(public readonly key: ProductType) {
    super();
  }
}
